import React from "react";

function Assietes() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>
            voici nos assietes N'hésitez pas appelez le 09 50 85 13 53
          </span>
          Nos Assiestes{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="https://media-cdn.tripadvisor.com/media/photo-s/18/ca/e7/84/notre-assiette-kebab.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Assiete Classic <span>8.5€</span>
            </h4>
            <p>Viandes au choix, crudités , riz ou blé cassé , légumes</p>
          </div>
        </div>
        <div class="single-menu">
          <img src="https://www.mimifood.fr/produit/2219_129.png" alt="" />
          <div class="menu-content">
            <h4>
              Assiete double <span>10.5€</span>
            </h4>
            <p> Viandes au choix, crudités , riz ou blé cassé , légumes</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://maxidelices.fr/wp-content/uploads/2017/08/assiette-kebab_0099-600x398.png"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Assiete Triple<span>1€</span>
            </h4>
            <p>Viandes au choix, crudités , riz ou blé cassé , légumes</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Assietes;
